import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import {
  // YesNo,
  Grade,
  Link,
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdGrade extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
  }
  //
  constructor(props) {
    super(props)
    //
    const { ticker, fund_legal_name, fund_id,
            investment_vehicle_id } = props.shareclass

    // make ticker safe for URL
    const sTicker = ticker || 'N'

    const urlBuilder = (route, profilePath) => {
      return route + '/' +
        format.sanitize(fund_legal_name) + '/' +
        sTicker + '/' +
        profilePath + '/' +
        fund_id + '/' +
        investment_vehicle_id
    }

    let urlOutsideSite = null
    let title = null

    // switch logic on fieldName
    switch (props.fieldName) {
      case 'grade_fossil':
        if (config.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.fff + '/fund',
            'fossil-fuel-investments'
          )
          title = props.shareclass.name + ' | Fossil Free Funds'
        }
        break
      case 'grade_fossil_bank':
        if (config.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.fff + '/fund',
            'fossil-finance-insurance'
          )
          title = props.shareclass.name + ' | Fossil Free Funds'
        }
        break
      case 'grade_fossil_insure':
        if (config.app.title !== 'Fossil Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.fff + '/fund',
            'fossil-finance-insurance'
          )
          title = props.shareclass.name + ' | Fossil Free Funds'
        }
        break
      case 'grade_deforestation':
        if (config.app.title !== 'Deforestation Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.dff + '/fund',
            'profile'
          )
          title = props.shareclass.name + ' | Deforestation Free Funds'
        }
        break
      case 'grade_gender_equality':
        if (
          config.app.title !== 'Gender Equality Funds' &&
          config.app.title !== 'Social Justice Funds'
        ) {
          urlOutsideSite = urlBuilder(
            config.links.gef + '/fund',
            'gender-lens-score'
          )
          title = props.shareclass.name + ' | Gender Equality Funds'
        }
        break
      case 'grade_dei':
        if (
          config.app.title !== 'Social Justice Funds'
        ) {
          urlOutsideSite = urlBuilder(
            config.links.sjf + '/fund',
            'profile'
          )
          title = props.shareclass.name + ' | Social Justice Funds'
        }
        break
      case 'grade_rji':
        if (
          config.app.title !== 'Social Justice Funds'
        ) {
          urlOutsideSite = urlBuilder(
            config.links.sjf + '/fund',
            'profile'
          )
          title = props.shareclass.name + ' | Social Justice Funds'
        }
        break
      case 'grade_hrc':
        if (
          config.app.title !== 'Social Justice Funds'
        ) {
          urlOutsideSite = urlBuilder(
            config.links.sjf + '/fund',
            'profile'
          )
          title = props.shareclass.name + ' | Social Justice Funds'
        }
        break
      case 'grade_military':
        if (config.app.title !== 'Weapon Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.wff + '/fund',
            'weapon-investments'
          )
          title = props.shareclass.name + ' | Weapon Free Funds'
        }
        break
      case 'grade_guns':
        if (config.app.title !== 'Gun Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.gff + '/fund',
            'gun-investments'
          )
          title = props.shareclass.name + ' | Gun Free Funds'
        }
        break
      case 'grade_prison_industrial_complex':
        if (config.app.title !== 'Prison Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.pff + '/fund',
            'prison-industrial-complex-investments'
          )
          title = props.shareclass.name + ' | Gun Free Funds'
        }
        break
      case 'grade_tobacco':
        if (config.app.title !== 'Tobacco Free Funds') {
          urlOutsideSite = urlBuilder(
            config.links.tff + '/fund',
            'tobacco-profile'
          )
          title = props.shareclass.name + ' | Tobacco Free Funds'
        }
        break
      default:
        break
    }
    //
    this.state = {
      urlOutsideSite,
      title
    }
  }
  //
  render() {
    //
    if (this.state.urlOutsideSite) {
      return <td styleName='col col-grade'>
        <Link
          to={this.state.urlOutsideSite}
          title={this.state.title}
        >
          <div styleName='score-wrapper' >
            <Grade grade={this.props.shareclass[this.props.fieldName]} square/>
          </div>
        </Link>
      </td>
    }
    //
    return <td
      styleName='col col-grade'
      onClick={
        this.props.fieldName === 'grade_fossil_bank' || this.props.fieldName === 'grade_fossil_insure' ?
          this.props.clickShareclass(this.props.shareclass, 'fossil-finance-insurance') :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      <div styleName='score-wrapper' >
        <Grade grade={this.props.shareclass[this.props.fieldName]} square/>
      </div>
    </td>
  }
}